// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__O25NC","inner":"Header_inner__gTFrK","logo":"Header_logo__QNgKp"};